import React from 'react';
import { useDispatch } from 'react-redux';
import Tour from 'reactour';
import { cleanupTeamHomeTour, setupTeamHomeTour } from 'redux/actions/tours';
import { saveTour } from 'redux/thunks';
import './TeamHomeTour.scss';

interface TeamHomeTourProps {
	open: boolean;
	userName: string;
	onClose: () => void;
}

const TeamHomeTour = (props: TeamHomeTourProps) => {
	const { open, userName, onClose } = props;
	const dispatch = useDispatch();

	const afterOpen = () => {
		dispatch(setupTeamHomeTour(userName));
		dispatch(saveTour('TeamHomeTour'));
	};

	const requestClose = () => {
		dispatch(cleanupTeamHomeTour());
		onClose();
	};

	const steps = [
		{
			selector: '',
			content: () => (
				<>
					<div className='team-home-tour__header'>Welcome to Tokens of Appreciation!</div>
					<div>This tour will walk you through the setup of the home screen.</div>
					<div className='team-home-tour__paragraph'>
						You will notice a few more tours popup in the app to introduce of the functionality on that page.
					</div>
					<div className='team-home-tour__paragraph'>You can always exit the tour with the "X" in the top right corner of this box</div>
					<div className='team-home-tour__footer'>We hope you enjoy using the app!</div>
				</>
			),
		},
		{
			selector: '.team-panel-container',
			content: 'In this panel you can see the teams that you are a member of, you can even select the star icons to favorite and unfavorite teams',
		},
		{
			selector: '.shout-out-button',
			content: () => (
				<>
					<div>Aren't on a team with someone but still want to give them recognition? Send them a shout-out!</div>
					<div className='team-home-tour__paragraph'>A shout-out is a way to give someone recognition without being on a team with them.</div>
					<div className='team-home-tour__paragraph'>
						While shout-outs dont include tokens, you can include a message recognizing them for the work they did.
					</div>
					<div className='team-home-tour__footer'>These shout-outs will show up in every team the person is on</div>
				</>
			),
		},
		{
			selector: '.send-tokens-button-wrapper',
			content: `When you're ready, you can send tokens to your team members to recognize good work they've done`,
		},
		{
			selector: '.team-details-btn',
			content: 'Selecting "Team Details" allows you to view and modify settings for your current team',
		},
		{
			selector: '.banner-tabs__all-tokens',
			content: 'Selecting here shows you all the tokens sent to everyone in your team',
		},
		{
			selector: '.banner-tabs__my-tokens',
			content: 'From here you can see all the tokens that have been given to you on this team',
		},
		{
			selector: '.post-item-paper',
			content: 'This is an example of a post in Tokens of Appreciation',
		},
		{
			selector: '.post-item__title-content-tokens',
			content: 'Here you can see how many tokens were given',
		},
		{
			selector: '.post-item__title-content-author',
			content: 'Who gave the tokens',
		},
		{
			selector: '.post-item__comment',
			content:
				'And who they gave it to, along with the message they send (its a good idea to send a message along with tokens so that its more meaningful)',
		},
		{
			selector: '.LikeButton',
			content: 'You can also like a post to show your support!',
		},
		{
			selector: '.AddButton',
			content: 'Think that someone didnt get enough tokens for the work they did? You can add tokens onto a post ',
		},
		{
			selector: '.leaderboard-panel',
			content: 'From this panel you can see the highest token holders on the team',
		},
		{
			selector: '.team-options-accordion',
			content: 'In here you can invite new members to the team, leave the team and select what notifications youd like to receive',
		},
		{
			selector: '.page-credits',
			content: 'Have questions? Find a bug? Have feedback on how great the app is? Let us know!',
		},
		{
			selector: '.header__text--link',
			content: 'If you ever want to redo the application tours, you can reset them here',
		},
	];

	return (
		<Tour
			steps={steps}
			closeWithMask={false}
			disableFocusLock={true}
			disableInteraction={true}
			showCloseButton={true}
			disableKeyboardNavigation={['esc']}
			isOpen={open}
			accentColor='#8524AA'
			lastStepNextButton={<div style={{ color: '#8524AA' }}>Get Started</div>}
			onRequestClose={requestClose}
			onAfterOpen={afterOpen}
		/>
	);
};

export default TeamHomeTour;
